import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';
import { DevPlanProvider } from './context/DevPlanContext';
import App from './App';
import './index.css';

// HOW TO GET YOUR DSN:
//   sentry.io → New Project → React → copy the DSN.
// SENTRY_AUTH_TOKEN (for source-map uploads) goes in .env.local — never commit it.
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  integrations: [Sentry.browserTracingIntegration()],
  // Capture 10% of transactions for performance monitoring
  tracesSampleRate: 0.1,
  // Only send events in production
  enabled: import.meta.env.PROD,
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <DevPlanProvider>
          <App />
        </DevPlanProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
